var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./items-slider.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3b608d9a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./items-slider.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/home-geolocal/components/items-slider/items-slider.vue
// module id = 260
// module chunks = 0